module.exports = __webpack_public_path__ + "img/6516.705f9906.jpg";